var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlusButtonPrimary2Z(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2573,
    cy: 24,
    r: 24,
    fill: "#97144D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2573 14C24.6362 14 24.9996 14.1505 25.2675 14.4184C25.5354 14.6863 25.6859 15.0497 25.6859 15.4286V22.5714H32.8288C33.2076 22.5714 33.571 22.7219 33.8389 22.9898C34.1068 23.2578 34.2573 23.6211 34.2573 24C34.2573 24.3789 34.1068 24.7422 33.8389 25.0102C33.571 25.2781 33.2076 25.4286 32.8288 25.4286H25.6859V32.5714C25.6859 32.9503 25.5354 33.3137 25.2675 33.5816C24.9996 33.8495 24.6362 34 24.2573 34C23.8784 34 23.5151 33.8495 23.2472 33.5816C22.9793 33.3137 22.8288 32.9503 22.8288 32.5714V25.4286H15.6859C15.307 25.4286 14.9437 25.2781 14.6757 25.0102C14.4078 24.7422 14.2573 24.3789 14.2573 24C14.2573 23.6211 14.4078 23.2578 14.6757 22.9898C14.9437 22.7219 15.307 22.5714 15.6859 22.5714H22.8288V15.4286C22.8288 15.0497 22.9793 14.6863 23.2472 14.4184C23.5151 14.1505 23.8784 14 24.2573 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusButtonPrimary2Z);
export default __webpack_public_path__ + "static/media/ic_plus_button_primary_2z.bed632e6dcc57ad879d17e683ece3bdf.svg";
export { ForwardRef as ReactComponent };